import { Link } from 'react-router-dom';
import { aboutInfo } from '@/mocks/about';

export default function BrandStory() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1">
            <span className="text-xs font-medium text-primary-600 uppercase tracking-wider mb-3 block">
              关于久久精品
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-5">
              品质，是我们唯一的信仰
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              {aboutInfo.story.split('\n\n')[0]}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {aboutInfo.story.split('\n\n')[1]}
            </p>
            <div className="flex flex-wrap gap-4 mb-6">
              {aboutInfo.values.slice(0, 4).map((v, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={`${v.icon}`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800">{v.title}</span>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex-1 w-full">
            <div className="relative overflow-hidden rounded-lg aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20artisan%20workshop%20with%20handcrafted%20ceramic%20pieces%20and%20wooden%20tools%20on%20display%2C%20natural%20light%20streaming%20through%20large%20windows%2C%20authentic%20craftsmanship%20atmosphere%2C%20minimalist%20elegant%20aesthetic%20with%20warm%20neutral%20tones&width=800&height=600&seq=brand-story-01&orientation=landscape"
                alt="久久精品 匠心工坊"
                title="久久精品——品质经久不衰"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}